'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.seconds;


// WEBPACK FOOTER //
// ./~/sugar-date/number/seconds.js